import { Link } from 'react-router-dom';
import SearchBox from '@/components/feature/SearchBox';
import { hotTags, sites } from '@/mocks/sites';
import { formatVisits, sortSites } from '@/utils/siteUtils';

export default function HomeSidebar() {
  const ranking = sortSites(sites, 'hot').slice(0, 8);

  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-search-eye-line text-primary-500"></i>
          快速搜索
        </h3>
        <p className="mt-1 text-xs text-foreground-500">输入关键词，马上找到目标网站</p>
        <div className="mt-3">
          <SearchBox placeholder="搜索网站…" />
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-price-tag-3-line text-accent-500"></i>
          热门标签
        </h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-bar-chart-2-line text-primary-500"></i>
          热门排行
        </h3>
        <ul className="mt-2 divide-y divide-background-200">
          {ranking.map((site, idx) => (
            <li key={site.id}>
              <Link
                to={`/detail/${site.id}`}
                className="group flex items-center gap-3 py-2.5"
              >
                <span
                  className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded text-[11px] font-semibold ${
                    idx < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {idx + 1}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-foreground-700 group-hover:text-primary-600">
                  {site.name}
                </span>
                <span className="flex-shrink-0 text-xs text-foreground-400">{formatVisits(site.visits)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}